import { FC, useEffect, useState } from "react";
import KickImage from 'Reuseables/KickImage';

//Components
import Component from "./Component";

//Actions
import { getOrderDetails, getSticker } from "../../../../actions/shipperAction";

//Interfaces
import { WrapperInterface } from "./definitions";
import { OrderDetailsInterface } from "../definitions"

const Wrapper: FC<WrapperInterface> = ({
  continueAction,
  pickupCreatedData
}) => {
  const { order_id } = pickupCreatedData || {};

  const downloadHandler = async () => {
    await getSticker(order_id)
      .then(res => res.data)
      .then(res => { window.open(res.data, "_blank") })
  }

  return (
    <Component
      order_id={order_id}
      downloadHandler={downloadHandler}
      continueAction={continueAction}
    />
  )
}
export default Wrapper;